module.exports = __webpack_public_path__ + "images/emoji/spades.e17aca598f0241658bd4.png";